<template>
  <el-card>
    <div slot="header">
      <span>Képek</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="onCreate"
      >
        Új kép
      </el-button>
    </div>
    <list
      :images="images"
      :showDialog="showDialog"
      :imageFormType="imageFormType"
      @closeDialog="showDialog = false"
      @openCreateDialog="onOpenCreate"
      @openUpdateDialog="onOpenUpdate"
      @change="onChange"
      @add="onImageCreate"
    />
  </el-card>
</template>

<script>
  import List from './Images/List';

  export default {
    components: { List },
    props: ['images'],
    data() {
      return {
        showDialog: false,
        imageFormType: 'add',
        basicData: {},
        rules: {
          name: [
            {
              required: true,
              message: 'Név megadása kötelező',
              trigger: 'change'
            }
          ],
        }
      };
    },
    computed: {
      products() {
        return this.$store.getters['product/products'];
      },
    },
    watch: {
      product(newVal) {
        this.basicData = Object.assign({}, newVal);
      },
    },
    methods: {
      onCreate() {
        this.imageFormType = 'add';
        this.showDialog = true;
      },
      onImageCreate(image) {
        this.$emit('add', {
          ...image,
          key: Math.random().toString(36).substring(7),
        });
      },
      onChange(images) {
        this.$emit('imageChange', images);
      },
      onOpenCreate() {
        this.imageFormType = 'add';
        this.showDialog = true;
      },
      onOpenUpdate() {
        this.imageFormType = 'update';
        this.showDialog = true;
      },
    },
  };
</script>
